import Vue from 'vue'
import store from '@state/store'
import DalinkApp from './DalinkApp'

import { createPinia, PiniaVuePlugin } from 'pinia'

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

import { i18n } from '@src/localization/config'

import './directives'

import VueTheMask from 'vue-the-mask'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(VueTheMask)

import GAPlugin from './plugins/ga'
import TMRPlugin from './plugins/tmr'

Vue.use(GAPlugin)
Vue.use(TMRPlugin)

import createRouter from '@router/dalink'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Icon from '@components/BaseComponents/Icon'
import Modal from '@components/BaseComponents/Modal'
import Loader from '@components/BaseComponents/Loader'

Vue.component('icon', Icon)
Vue.component('modal', Modal)
Vue.component('loader', Loader)

// Front ENV & Sentry setup
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import frontConfig from '@services/frontConfig'

frontConfig
  .onReady()
  .then(async () => {
    const dsn = frontConfig.getSentryDsn(process.env.VUE_APP_NAME)

    if (PRODUCTION_MODE) {
      if (dsn) {
        Sentry.init({
          integrations: [new Integrations.Vue({ Vue, attachProps: true })],
          release: `vue-dashboard@${process.env.VUE_APP_PACKAGE_VERSION}`,
          environment: process.env.NODE_ENV,
          dsn,
          autoSessionTracking: false,
        })
      }
    }

    if (document.getElementById('dalink-app')) {
      console.log('[Dalink app] Creating vm...')

      new Vue({
        router: createRouter(pinia),
        store,
        i18n,
        pinia,
        render: h => h(DalinkApp),
      }).$mount('#dalink-app')
    }
  })

